/*
 * NOBL-VP-01 (2026-10-12): keep every bundle price display in step with the selected variant.
 * Data comes from snippets/nobl-variant-prices.liquid (one JSON block per product, formatted by
 * Shopify in the shopper's currency). Only elements that opt in are touched:
 *   data-nobl-vp-product="<product id>"  +  data-nobl-vp="price|compare|savings|pct|badge|inst|instlead"
 *   data-nobl-vp-sale-only   -> hidden (display:none) when the selected variant has no discount
 *   data-nobl-vp-prefix="…"  -> text kept in front of the value (e.g. "Worth ")
 *   data-nobl-vp-strip="a|b" -> strings removed from the value (UAE "Dhs")
 * Works with Dawn (pub/sub "variant-change") and Prestige ("variant:change"), with a fallback that
 * reads the product form's variant id after any change. Same file in NA, CA, UK and EU.
 */
(function () {
  if (window.__noblVariantPriceSync) return;
  window.__noblVariantPriceSync = true;

  var cache = {};
  var last = {};

  function getData(pid) {
    if (cache.hasOwnProperty(pid)) return cache[pid];
    var el = document.querySelector('script[data-nobl-vp-json="' + pid + '"]');
    var d = null;
    if (el) { try { d = JSON.parse(el.textContent); } catch (e) { d = null; } }
    cache[pid] = d;
    return d;
  }

  function productIds() {
    var seen = {};
    var out = [];
    document.querySelectorAll('[data-nobl-vp-product]').forEach(function (el) {
      var id = el.getAttribute('data-nobl-vp-product');
      if (id && !seen[id]) { seen[id] = 1; out.push(id); }
    });
    return out;
  }

  function setText(el, text) {
    if (el.textContent.replace(/\s+/g, ' ').trim() !== String(text).replace(/\s+/g, ' ').trim()) {
      el.textContent = text;
    }
  }

  function apply(pid, vid, force) {
    var d = getData(pid);
    if (!d || vid == null) return false;
    vid = String(vid);
    var v = d[vid];
    if (!v) return false;
    if (!force && last[pid] === vid) return true;
    last[pid] = vid;

    document.querySelectorAll('[data-nobl-vp-product="' + pid + '"]').forEach(function (el) {
      var key = el.getAttribute('data-nobl-vp');
      if (key) {
        var val = null;
        if (key === 'price') val = v.p;
        else if (key === 'compare') val = v.c;
        else if (key === 'savings') val = v.s;
        else if (key === 'badge') val = v.b;
        else if (key === 'inst') val = v.i;
        else if (key === 'instlead') val = v.il;
        else if (key === 'pct') {
          var t = el.textContent;
          if (v.sale && /\d+(?=\s*%)/.test(t)) {
            var nt = t.replace(/\d+(?=\s*%)/, String(v.pct));
            if (nt !== t) el.textContent = nt;
          }
        }
        if (val !== null && val !== undefined && val !== '') {
          var strip = el.getAttribute('data-nobl-vp-strip');
          if (strip) {
            strip.split('|').forEach(function (s) { if (s) val = val.split(s).join(''); });
            val = val.trim();
          }
          setText(el, (el.getAttribute('data-nobl-vp-prefix') || '') + val);
        }
      }
      if (el.hasAttribute('data-nobl-vp-sale-only')) {
        el.style.display = v.sale ? '' : 'none';
      }
    });
    return true;
  }

  /* Variant id currently selected in this product's add-to-cart form(s). */
  function currentVariantId(pid) {
    var d = getData(pid);
    if (!d) return null;
    /* Main product form first (Dawn product-info / Prestige main-product section), then any form. */
    var scopes = [
      'product-info form[action*="/cart/add"] [name="id"]',
      '.shopify-section--main-product [name="id"]',
      '[id*="__main"] [name="id"]',
      'form[action*="/cart/add"] [name="id"], [name="id"][form]'
    ];
    for (var s = 0; s < scopes.length; s++) {
      var inputs = document.querySelectorAll(scopes[s]);
      for (var i = 0; i < inputs.length; i++) {
        var val = String(inputs[i].value || '');
        if (val && d[val]) return val;
      }
    }
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m && d[m[1]]) return m[1];
    return null;
  }

  function applyVariant(vid) {
    if (vid == null) return;
    productIds().forEach(function (pid) { apply(pid, vid); });
  }

  function syncFromForms(force) {
    productIds().forEach(function (pid) {
      var vid = currentVariantId(pid);
      if (vid) apply(pid, vid, force);
    });
  }

  /* Prestige: the product form fires a bubbling "variant:change" with detail.variant. */
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v && v.id) applyVariant(v.id);
  });

  /* Dawn: pub/sub "variant-change" with data.variant. */
  function hookDawn() {
    if (window.__noblVPDawn) return;
    /* PUB_SUB_EVENTS is a top-level const in Dawn's constants.js: global, but not on window. */
    var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
    if (typeof window.subscribe === 'function' && events && events.variantChange) {
      window.__noblVPDawn = true;
      window.subscribe(events.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (v && v.id) applyVariant(v.id);
      });
    }
  }

  /* Fallback for any picker: read the form's variant id shortly after a change. */
  document.addEventListener('change', function () {
    setTimeout(function () { syncFromForms(false); }, 200);
    setTimeout(function () { syncFromForms(false); }, 900);
  });

  function init() {
    hookDawn();
    syncFromForms(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', hookDawn);
  /* Back/forward cache: the page can come back with another variant selected. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncFromForms(true); });
})();
